import React from 'react';

const SurgicalBlankets = () => {
  return (
    <div className="container" style={{ padding: '40px 20px', backgroundColor: '#e0f7fa' }}>
      <div className="row">
        {/* WWC 101 */}
        <div className="col-12 d-flex flex-wrap border-bottom pb-4 mb-4" style={{ backgroundColor: '#e0f7fa' }}>
          <div className="col-md-6 p-4 d-flex justify-content-center align-items-center" style={{ border: '1px solid #ddd', borderRadius: '10px', backgroundColor: '#ffffff' }}>
            <div style={{ textAlign: 'center' }}>
              <h4 style={{ color: '#007BFF' }}>WWC 101</h4>
              <p><strong>Full Body Multi Access Blankets</strong></p>
              <ul style={{ fontSize: '16px' }}>
                <li>Size: 110 cm x 200 cm</li>
                <li>Number of air inlets: 1</li>
                <li>Easy access to chest tubes, arteries, and pulse checking</li>
                <li>Designed for performing head and neck surgery</li>
                <li>Suitable for head and neck surgery</li>
                <li>Covers the entire body, suitable for surgical interventions in recovery rooms and intensive care</li>
              </ul>
            </div>
          </div>
          <div className="col-md-6 p-4 d-flex justify-content-center align-items-center">
            <img
              src="/images/keyword/2.jpg" // Replace with actual image path
              alt="WWC 101 Blanket"
              className="img-fluid"
              style={{ borderRadius: '10px', border: '1px solid #ddd' }}
            />
          </div>
        </div>

        {/* WWC 102 */}
        <div className="col-12 d-flex flex-wrap border-bottom pb-4 mb-4" style={{ backgroundColor: '#e0f7fa' }}>
          <div className="col-md-6 p-4 d-flex justify-content-center align-items-center" style={{ border: '1px solid #ddd', borderRadius: '10px', backgroundColor: '#ffffff' }}>
            <div style={{ textAlign: 'center' }}>
              <h4 style={{ color: '#007BFF' }}>WWC 102</h4>
              <p><strong>Upper Body Blanket</strong></p>
              <ul style={{ fontSize: '16px' }}>
                <li>Size: 120 cm x 125 cm</li>
                <li>Number of inlets: 2</li>
                <li>Designed for lower body surgery to cover the patient's upper torso, upper extremities, neck, and head</li>
                <li>Suitable for lower abdomen, gynecology, urology, anorectic surgery, and lower extremity orthopedic surgery</li>
              </ul>
            </div>
          </div>
          <div className="col-md-6 p-4 d-flex justify-content-center align-items-center">
            <img
              src="/images/ww2.jpg" // Replace with actual image path
              alt="WWC 102 Blanket"
              className="img-fluid"
              style={{ borderRadius: '10px', border: '1px solid #ddd' }}
            />
          </div>
        </div>

        {/* WWC 103 */}
        <div className="col-12 d-flex flex-wrap border-bottom pb-4 mb-4" style={{ backgroundColor: '#e0f7fa' }}>
          <div className="col-md-6 p-4 d-flex justify-content-center align-items-center" style={{ border: '1px solid #ddd', borderRadius: '10px', backgroundColor: '#ffffff' }}>
            <div style={{ textAlign: 'center' }}>
              <h4 style={{ color: '#007BFF' }}>WWC 103</h4>
              <p><strong>Lower Body Blanket</strong></p>
              <ul style={{ fontSize: '16px' }}>
                <li>Size: 120 cm x 120 cm</li>
                <li>Designed for upper body surgery</li>
                <li>Suitable for head (neurosurgery), neck, chest, cardiothoracic surgery, breast surgery, upper limbs (orthopedics), upper abdomen general surgery</li>
              </ul>
            </div>
          </div>
          <div className="col-md-6 p-4 d-flex justify-content-center align-items-center">
            <img
              src="/images/ww3.jpg" // Replace with actual image path
              alt="WWC 103 Blanket"
              className="img-fluid"
              style={{ borderRadius: '10px', border: '1px solid #ddd' }}
            />
          </div>
        </div>

        {/* WWC 104 */}
        <div className="col-12 d-flex flex-wrap border-bottom pb-4 mb-4" style={{ backgroundColor: '#e0f7fa' }}>
          <div className="col-md-6 p-4 d-flex justify-content-center align-items-center" style={{ border: '1px solid #ddd', borderRadius: '10px', backgroundColor: '#ffffff' }}>
            <div style={{ textAlign: 'center' }}>
              <h4 style={{ color: '#007BFF' }}>WWC 104</h4>
              <p><strong>Surgical Access Blanket</strong></p>
              <ul style={{ fontSize: '16px' }}>
                <li>Size: 110 cm x 200 cm</li>
                <li>Suitable for laminectomy, spine surgery, and abdominal surgery</li>
              </ul>
            </div>
          </div>
          <div className="col-md-6 p-4 d-flex justify-content-center align-items-center">
            <img
              src="/images/ww4.jpg" // Replace with actual image path
              alt="WWC 104 Blanket"
              className="img-fluid"
              style={{ borderRadius: '10px', border: '1px solid #ddd' }}
            />
          </div>
        </div>

        {/* WWC 105 */}
        <div className="col-12 d-flex flex-wrap border-bottom pb-4 mb-4" style={{ backgroundColor: '#e0f7fa' }}>
          <div className="col-md-6 p-4 d-flex justify-content-center align-items-center" style={{ border: '1px solid #ddd', borderRadius: '10px', backgroundColor: '#ffffff' }}>
            <div style={{ textAlign: 'center' }}>
              <h4 style={{ color: '#007BFF' }}>WWC 105</h4>
              <p><strong>Abdominal Excess Blanket</strong></p>
              <ul style={{ fontSize: '16px' }}>
                <li>Size: 195 cm x 184 cm</li>
                <li>Suitable for laminectomy, spine surgery, abdominal surgery, and transplant surgery</li>
              </ul>
            </div>
          </div>
          <div className="col-md-6 p-4 d-flex justify-content-center align-items-center">
            <img
              src="/images/ww5.jpg" // Replace with actual image path
              alt="WWC 105 Blanket"
              className="img-fluid"
              style={{ borderRadius: '10px', border: '1px solid #ddd' }}
            />
          </div>
        </div>

        {/* WWC 106 */}
        <div className="col-12 d-flex flex-wrap pb-4 mb-4" style={{ backgroundColor: '#e0f7fa' }}>
          <div className="col-md-6 p-4 d-flex justify-content-center align-items-center" style={{ border: '1px solid #ddd', borderRadius: '10px', backgroundColor: '#ffffff' }}>
            <div style={{ textAlign: 'center' }}>
              <h4 style={{ color: '#007BFF' }}>WWC 106</h4>
              <p><strong>Cardiac Excess Blanket</strong></p>
              <ul style={{ fontSize: '16px' }}>
                <li>Size: 195 cm x 120 cm</li>
                <li>Suitable for heart and chest surgery</li>
              </ul>
            </div>
          </div>
          <div className="col-md-6 p-4 d-flex justify-content-center align-items-center">
            <img
              src="/images/ww6.jpg" // Replace with actual image path
              alt="WWC 106 Blanket"
              className="img-fluid"
              style={{ borderRadius: '10px', border: '1px solid #ddd' }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SurgicalBlankets;
